import { ReactNode, useEffect, useState } from "react";
import CustomModal from "./CustomModal";

export interface CustomPromptProps {
    isVisible: boolean;
    onClose: () => void;
    onConfirm: () => void;
    disableExitConfirmation?:boolean,
    message: string | ReactNode;
    title?: string;
    PrimaryText?: string;
    secondaryText?: string;
}

export const emptyCustomPromptProps: CustomPromptProps = {
    isVisible: false,
    onClose: () => {},
    onConfirm: () => {},
    disableExitConfirmation:false,
    message: '',
    title: undefined,
    PrimaryText: undefined,
    secondaryText: undefined,
};

export const emptyCustomPromptPropsWithExitConfirmation: CustomPromptProps = {
    isVisible: false,
    onClose: () => {},
    onConfirm: () => {},
    disableExitConfirmation:true,
    message: '',
    title: undefined,
    PrimaryText: undefined,
    secondaryText: undefined,
};

export const CustomPrompt: React.FC<CustomPromptProps> = ({
    isVisible,
    onClose,
    onConfirm,
    message,
    disableExitConfirmation,
    title = 'Confirm Action'.toTranslatedDisplay(),
    PrimaryText: confirmText = 'OK'.toTranslatedDisplay(),
    secondaryText: cancelText = 'Cancel'.toTranslatedDisplay(),
}) => {
    const [exitConfirmed, setExitConfirmed] = useState(false);

    if (!isVisible) return null;

    function handleModalClose(): void {
        onClose();
    }

    function handleModalConfirm(): void {
        setExitConfirmed(true);
        onConfirm();
    }
    return (
        (!exitConfirmed || disableExitConfirmation) && (
            <CustomModal
                title={title}
                isVisible={isVisible}
                onClose={handleModalClose}
                size="small"
                body={
                    <>
                        <div className="modal-body">
                            <p>{message}</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleModalClose}>
                                {cancelText}
                            </button>
                            <button type="button" className="btn btn-primary" onClick={handleModalConfirm}>
                                {confirmText}
                            </button>
                        </div>
                    </>
                }
                id=""
                onSave={() => {}}
            />
        )
    );
};
